import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/app/[locale]/error.tsx");
